module.exports = __webpack_public_path__ + "img/img_half_slim_belt.befcc81b.png";